var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPodcasts(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 23,
    viewBox: "0 0 17 23",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.00942 0.271881C10.2186 0.271881 12.0094 2.06274 12.0094 4.27188V11.2719C12.0094 13.481 10.2186 15.2719 8.00942 15.2719C5.80028 15.2719 4.00942 13.481 4.00942 11.2719V4.27188C4.00942 2.06274 5.80028 0.271881 8.00942 0.271881ZM9.00946 19.21V20.2719H12.0095V22.2719H4.00946V20.2719H7.00946V19.21C3.06315 18.7179 0.00946045 15.3515 0.00946045 11.2719V9.27188H2.00946V11.2719C2.00946 14.5856 4.69575 17.2719 8.00946 17.2719C11.3232 17.2719 14.0095 14.5856 14.0095 11.2719V9.27188H16.0095V11.2719C16.0095 15.3515 12.9558 18.7179 9.00946 19.21ZM6.00945 4.27188C6.00945 3.16731 6.90488 2.27188 8.00945 2.27188C9.11402 2.27188 10.0095 3.16731 10.0095 4.27188V11.2719C10.0095 12.3765 9.11402 13.2719 8.00945 13.2719C6.90488 13.2719 6.00945 12.3765 6.00945 11.2719V4.27188Z",
    fill: "#898F97"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPodcasts);
export default __webpack_public_path__ + "static/media/podcasts.bdc0a0fdc42cd9717f5f645fa84a8778.svg";
export { ForwardRef as ReactComponent };